import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-funcion';

/**
 * Get Tipos De Funciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeFunciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo De Función
 * @params {number} id
 * @returns {Promise<object|null>};
 */
export const getTipoDeFuncion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST TIpo De Función
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeFuncion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo De Función
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeFuncion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo De Función
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteTipoDeFuncion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
